var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineCircleRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.89074 9.97407C6.13482 9.73 6.53055 9.73 6.77462 9.97407L8.83268 12.0321L14.2241 6.64074C14.4682 6.39666 14.8639 6.39666 15.108 6.64074C15.352 6.88482 15.352 7.28055 15.108 7.52462L9.27462 13.358C9.03055 13.602 8.63482 13.602 8.39074 13.358L5.89074 10.858C5.64666 10.6139 5.64666 10.2182 5.89074 9.97407Z",
    fill: "#FF4336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4993 2.29102C6.24215 2.29102 2.79102 5.74215 2.79102 9.99935C2.79102 14.2565 6.24215 17.7077 10.4993 17.7077C14.7565 17.7077 18.2077 14.2565 18.2077 9.99935C18.2077 5.74215 14.7565 2.29102 10.4993 2.29102ZM1.54102 9.99935C1.54102 5.0518 5.5518 1.04102 10.4993 1.04102C15.4469 1.04102 19.4577 5.0518 19.4577 9.99935C19.4577 14.9469 15.4469 18.9577 10.4993 18.9577C5.5518 18.9577 1.54102 14.9469 1.54102 9.99935Z",
    fill: "#FF4336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineCircleRed);
export default __webpack_public_path__ + "static/media/line_circle_red.95daf365243f2a36ff1d453caa34e483.svg";
export { ForwardRef as ReactComponent };